import {Injectable} from '@angular/core';
import {Page} from '../model/page';
import {GeneralService} from './general.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TeamworkReportsService extends GeneralService {
    constructor(
        protected http: HttpClient
    ) {
    super ( http );
    }
    
    public getDataList ( page: Page ): Observable<any> {
        const url = '/teamwork-reports/index';
        return this.getRestList ( page, url );
    }
    
    public export(page: Page): Observable<any> {
        const url = '/teamwork-reports/export';
        let params = new HttpParams();
        params = this.applyFilters(page, params);
        return this.http.get(url, {params: params});
    }

    public initialize () {
        return {
            CO1_ID: null,
            COMPANY_NAME: null,
            TICKETS: null,
            AGENT_REPLIES: null,
            CUSTOMER_REPLIES: null,
            TOTAL_MESSAGES: null
        };
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/teamwork-reports.service.ts